import { createAction } from '@reduxjs/toolkit';

import type { Cart, CartUpdateFields } from '.';

const check = {
  pending: createAction('cart/check/pending'),
  fulfilled: createAction('cart/check/fulfilled'),
  rejected: createAction('cart/check/rejected'),
};

const get = {
  pending: createAction('cart/get/pending'),
  fulfilled: createAction<Cart>('cart/get/fulfilled'),
  rejected: createAction('cart/get/rejected'),
};

const create = {
  pending: createAction('cart/create/pending'),
  fulfilled: createAction<Cart>('cart/create/fulfilled'),
  rejected: createAction('cart/create/rejected'),
};

const update = {
  pending: createAction<CartUpdateFields>('cart/update/pending'),
  fulfilled: createAction<CartUpdateFields>('cart/update/fulfilled'),
  rejected: createAction('cart/update/rejected'),
};

export default {
  check,
  get,
  create,
  update,
};
